export default function getGlobalMark(markSkills: number, markForm: number) {
  return Math.floor((2 * markForm + markSkills) / 3);
}